var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 310.57 157.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-127,.cls-131,.cls-132,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-15,.cls-150,.cls-16,.cls-17,.cls-174,.cls-18,.cls-183,.cls-185,.cls-188,.cls-3,.cls-32,.cls-34,.cls-4,.cls-5,.cls-6,.cls-7,.cls-76{mix-blend-mode:multiply;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}.cls-5{fill:url(#radial-gradient-3);}.cls-6{fill:url(#radial-gradient-4);}.cls-7{fill:url(#radial-gradient-5);}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11,.cls-12,.cls-133,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-186,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-71,.cls-75,.cls-82,.cls-84{mix-blend-mode:soft-light;}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-9);}.cls-17{fill:url(#linear-gradient-10);}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:#ae1815;}.cls-22{fill:url(#radial-gradient-6);}.cls-23{fill:url(#radial-gradient-7);}.cls-24{fill:url(#radial-gradient-8);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:url(#linear-gradient-17);}.cls-29{fill:url(#linear-gradient-18);}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-20);}.cls-32{fill:url(#linear-gradient-21);}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:#7f7f83;}.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-128,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46{mix-blend-mode:overlay;}.cls-36{fill:#87878a;}.cls-37{fill:#8e8e90;}.cls-38{fill:#969697;}.cls-39{fill:#9e9e9e;}.cls-40{fill:#a5a5a4;}.cls-41{fill:#adadab;}.cls-42{fill:#b4b4b1;}.cls-43{fill:#bcbcb8;}.cls-44{fill:#c4c4bf;}.cls-45{fill:#cbcbc5;}.cls-46{fill:#d3d3cc;}.cls-47{fill:url(#radial-gradient-9);}.cls-48{fill:url(#radial-gradient-10);}.cls-49{fill:url(#radial-gradient-11);}.cls-50{fill:url(#radial-gradient-12);}.cls-51{fill:url(#linear-gradient-24);}.cls-52{fill:url(#radial-gradient-13);}.cls-53{fill:url(#linear-gradient-25);}.cls-54{fill:url(#linear-gradient-26);}.cls-55{fill:url(#linear-gradient-27);}.cls-56{fill:url(#linear-gradient-28);}.cls-57{fill:url(#linear-gradient-29);}.cls-58{fill:url(#linear-gradient-30);}.cls-59{fill:url(#linear-gradient-31);}.cls-60{fill:url(#linear-gradient-32);}.cls-61{fill:url(#linear-gradient-33);}.cls-62{fill:url(#linear-gradient-34);}.cls-63{fill:url(#linear-gradient-35);}.cls-64{fill:url(#linear-gradient-36);}.cls-65{fill:url(#linear-gradient-37);}.cls-66{fill:url(#linear-gradient-38);}.cls-67{fill:url(#linear-gradient-39);}.cls-68{fill:url(#linear-gradient-40);}.cls-69{fill:#b1740f;}.cls-70{fill:#922415;}.cls-71{fill:url(#linear-gradient-41);}.cls-72{fill:url(#linear-gradient-42);}.cls-73{fill:url(#linear-gradient-43);}.cls-74{fill:url(#linear-gradient-44);}.cls-75{fill:url(#linear-gradient-45);}.cls-76{fill:url(#linear-gradient-46);}.cls-77{fill:url(#linear-gradient-47);}.cls-78{fill:url(#radial-gradient-14);}.cls-79{fill:url(#radial-gradient-15);}.cls-80{fill:url(#radial-gradient-16);}.cls-81{fill:url(#radial-gradient-17);}.cls-82{fill:url(#radial-gradient-18);}.cls-83{fill:url(#linear-gradient-48);}.cls-85{fill:gray;}.cls-86{fill:#8c8c8c;}.cls-87{fill:#979797;}.cls-88{fill:#a3a3a3;}.cls-89{fill:#aeaeae;}.cls-90{fill:#bababa;}.cls-91{fill:#c5c5c5;}.cls-92{fill:#d1d1d1;}.cls-93{fill:#dcdcdc;}.cls-94{fill:#e8e8e8;}.cls-95{fill:#f3f3f3;}.cls-133,.cls-139,.cls-173,.cls-205,.cls-206,.cls-207,.cls-208,.cls-209,.cls-210,.cls-211,.cls-212,.cls-213,.cls-214,.cls-215,.cls-216,.cls-217,.cls-218,.cls-219,.cls-220,.cls-96{fill:#fff;}.cls-97{fill:url(#radial-gradient-19);}.cls-98{fill:url(#radial-gradient-20);}.cls-99{fill:url(#radial-gradient-21);}.cls-100{fill:url(#radial-gradient-22);}.cls-101{fill:url(#linear-gradient-49);}.cls-102{fill:url(#radial-gradient-23);}.cls-103{fill:url(#linear-gradient-50);}.cls-104{fill:url(#linear-gradient-51);}.cls-105{fill:url(#linear-gradient-52);}.cls-106{fill:url(#linear-gradient-53);}.cls-107{fill:url(#linear-gradient-54);}.cls-108{fill:url(#linear-gradient-55);}.cls-109{fill:url(#linear-gradient-56);}.cls-110{fill:url(#linear-gradient-57);}.cls-111{fill:url(#linear-gradient-58);}.cls-112{fill:url(#linear-gradient-59);}.cls-113{fill:url(#linear-gradient-60);}.cls-114{fill:url(#linear-gradient-61);}.cls-115{fill:url(#linear-gradient-62);}.cls-116{fill:#868688;}.cls-117{fill:#8c8c8e;}.cls-118{fill:#939393;}.cls-119{fill:#999998;}.cls-120{fill:#a0a09e;}.cls-121{fill:#a6a6a3;}.cls-122{fill:#adada9;}.cls-123{fill:#b3b3ae;}.cls-124{fill:#babab3;}.cls-125{fill:#c0c0b9;}.cls-126{fill:#c7c7be;}.cls-127{fill:url(#linear-gradient-63);}.cls-128{fill:url(#linear-gradient-64);}.cls-129{mix-blend-mode:hard-light;fill:url(#linear-gradient-65);}.cls-130{fill:url(#linear-gradient-66);}.cls-131{fill:url(#linear-gradient-67);}.cls-132{fill:url(#linear-gradient-68);}.cls-134{fill:url(#linear-gradient-69);}.cls-135{fill:#232628;}.cls-136{fill:#637771;}.cls-137{fill:url(#radial-gradient-24);}.cls-138{fill:url(#linear-gradient-70);}.cls-140{fill:#f1f1f1;}.cls-141{fill:#e4e4e4;}.cls-142{fill:#d6d6d6;}.cls-143{fill:#c8c8c8;}.cls-144{fill:#bbb;}.cls-145{fill:#adadad;}.cls-146{fill:#a0a0a0;}.cls-147{fill:#929292;}.cls-148{fill:#848484;}.cls-149{fill:#777;}.cls-150{fill:#696969;}.cls-151{fill:#b74700;}.cls-152{fill:#b94a00;}.cls-153{fill:#bb4d00;}.cls-154{fill:#bc5000;}.cls-155{fill:#be5300;}.cls-156{fill:#c05600;}.cls-157{fill:#c25900;}.cls-158{fill:#c45c00;}.cls-159{fill:#c55f00;}.cls-160{fill:#c76200;}.cls-161{fill:#c96500;}.cls-162{fill:#cb6800;}.cls-163{fill:#cd6b00;}.cls-164{fill:#cf6e00;}.cls-165{fill:#d07100;}.cls-166{fill:#d27400;}.cls-167{fill:#d47700;}.cls-168{fill:#d67a00;}.cls-169{fill:#d87d00;}.cls-170{fill:#d98000;}.cls-171{fill:#db8300;}.cls-172{fill:#dd8600;}.cls-173,.cls-213{opacity:0.5;}.cls-175{fill:url(#linear-gradient-71);}.cls-176{fill:url(#linear-gradient-72);}.cls-177{fill:url(#linear-gradient-73);}.cls-178{fill:url(#linear-gradient-74);}.cls-179{fill:url(#linear-gradient-75);}.cls-180{fill:url(#linear-gradient-76);}.cls-181{fill:url(#linear-gradient-77);}.cls-182{fill:url(#linear-gradient-78);}.cls-183{fill:url(#linear-gradient-79);}.cls-184{fill:url(#linear-gradient-80);}.cls-185{fill:url(#linear-gradient-81);}.cls-186{fill:url(#linear-gradient-82);}.cls-187{fill:url(#linear-gradient-83);}.cls-188{fill:#a8b3af;}.cls-189{fill:#282b2d;}.cls-190{fill:#26292b;}.cls-191{fill:#24282a;}.cls-192{fill:#212426;}.cls-193{fill:#1f2224;}.cls-194{fill:#1d2123;}.cls-195{fill:#1b1f21;}.cls-196{fill:#1a1d1f;}.cls-197{fill:#181b1d;}.cls-198{fill:#161a1c;}.cls-199{fill:#14181a;}.cls-200{fill:#121618;}.cls-201{fill:#101416;}.cls-202{fill:#0f1215;}.cls-203{fill:#0d1113;}.cls-204{fill:#0b0f11;}.cls-205{opacity:0;}.cls-206{opacity:0.06;}.cls-207{opacity:0.13;}.cls-208{opacity:0.19;}.cls-209{opacity:0.25;}.cls-210{opacity:0.31;}.cls-211{opacity:0.38;}.cls-212{opacity:0.44;}.cls-214{opacity:0.56;}.cls-215{opacity:0.63;}.cls-216{opacity:0.69;}.cls-217{opacity:0.75;}.cls-218{opacity:0.81;}.cls-219{opacity:0.88;}.cls-220{opacity:0.94;}.cls-221{clip-path:url(#clip-path);}.cls-222{clip-path:url(#clip-path-2);}.cls-223{clip-path:url(#clip-path-3);}.cls-224{clip-path:url(#clip-path-4);}.cls-225{clip-path:url(#clip-path-5);}.cls-226{clip-path:url(#clip-path-6);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 230.24,
    cy: -201.09,
    r: 19.47,
    gradientTransform: "matrix(-7.98, 0, 0, 0.54, 1992, 254.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babbb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#bfc0be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#cdcecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 4176.1,
    cy: -900.23,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4424.23, 383.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#313230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6e706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 4184.86,
    cy: -923.15,
    r: 19.46,
    gradientTransform: "matrix(-1, 0, 0, 0.26, 4424.23, 383.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6f706e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a2a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#cacbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 4338.96,
    cy: -899.39,
    r: 19.46,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4331.6,
    cy: -913.72,
    r: 19.46,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1626.91,
    y1: 107.82,
    x2: 1626.91,
    y2: 124.29,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 232.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b1b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#464645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#20201f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1b1b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#131312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1626.91,
    y1: 115.37,
    x2: 1626.91,
    y2: 116.1,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 231.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1626.91,
    y1: 116.08,
    x2: 1626.91,
    y2: 116.82,
    gradientTransform: "matrix(1, 0, 0, -1, -1455.08, 232.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1602.93,
    y1: 116.09,
    x2: 1604.85,
    y2: 116.09,
    gradientTransform: "matrix(1, 0, 0, -1, -1408.85, 232.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbcbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#bebebd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9c9c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 11179.27,
    y1: 116.09,
    x2: 11181.19,
    y2: 116.09,
    gradientTransform: "translate(-11031.42)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1605.98,
    y1: 107.82,
    x2: 1605.98,
    y2: 124.29,
    gradientTransform: "matrix(1, 0, 0, -1, -1413.2, 232.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1647.78,
    y1: 107.82,
    x2: 1647.78,
    y2: 124.29,
    gradientTransform: "matrix(1, 0, 0, -1, -1496.82, 232.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1606.63,
    y1: 116.09,
    x2: 1607.37,
    y2: 116.09,
    gradientTransform: "matrix(1, 0, 0, -1, -1415.21, 232.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#6a7b75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7d8b86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#99a29f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#afb6b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1c4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#cdcece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1648.43,
    y1: 116.09,
    x2: 1649.17,
    y2: 116.09,
    gradientTransform: "matrix(1, 0, 0, -1, -1498.81, 232.19)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 11239.44,
    y1: 116.09,
    x2: 11240.18,
    y2: 116.09,
    gradientTransform: "translate(-11046.02)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 11197.63,
    y1: 116.09,
    x2: 11198.37,
    y2: 116.09,
    gradientTransform: "translate(-11046.02)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1773.97,
    y1: 113.7,
    x2: 1791.22,
    y2: 113.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#1d2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#25282a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3659.4,
    y1: 120.83,
    x2: 3659.4,
    y2: 116.6,
    gradientTransform: "matrix(1, 0, 0, -1, -3652.61, 237.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d3d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6c6c6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555553"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -4583.84,
    cy: 123.05,
    r: 18.31,
    gradientTransform: "translate(3418.59 3277.31) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -4583.84,
    cy: 123.05,
    r: 18.67,
    gradientTransform: "translate(4674.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#050503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#10100f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161615"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -4583.84,
    cy: 123.05,
    r: 12.97,
    gradientTransform: "translate(4674.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9d9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#d6d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#cbcbca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#b9b9b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a0a09e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#828280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#787876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#6b6b69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#595957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4f4f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#545452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#60605f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#646463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1739.86,
    y1: 111.8,
    x2: 1739.86,
    y2: 124.61,
    gradientTransform: "matrix(1, 0, 0, -1, -1680.96, 236.47)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3430.61,
    y1: -3317.63,
    x2: -3429.35,
    y2: -3317.63,
    gradientTransform: "matrix(1, 0, 0, 1.49, 3565.42, 5073.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6c6c6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d3d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3431.84,
    y1: -3298.06,
    x2: -3428.12,
    y2: -3298.06,
    gradientTransform: "matrix(1, 0, 0, 1.49, 3536.44, 5051.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#555553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5d5d5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#747472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#999998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a3a3a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4d4d4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5f5f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7d7d7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1634.59,
    y1: 103.54,
    x2: 1634.59,
    y2: 115.26,
    gradientTransform: "matrix(1, 0, 0, -1, -1470.43, 218.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6b6b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1634.59,
    y1: 112.4,
    x2: 1634.59,
    y2: 115.25,
    gradientTransform: "matrix(1, 0, 0, -1, -1470.43, 227.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9d9d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#444443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1741.18,
    y1: 104.77,
    x2: 1741.18,
    y2: 112.17,
    gradientTransform: "matrix(1, 0, 0, -1, -1683.61, 216.97)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1741.18,
    y1: 110.36,
    x2: 1741.18,
    y2: 112.16,
    gradientTransform: "matrix(1, 0, 0, -1, -1683.61, 222.53)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 9196.09,
    y1: 107.29,
    x2: 9196.09,
    y2: 114.87,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7c7e7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a9a9a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 9171.13,
    y1: 117.01,
    x2: 9220.65,
    y2: 117.01,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#70726f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a7adab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#bdc4c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#bec5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#d1d3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d4d7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d1d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c6cbc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#a9acaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7b7b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#777774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 9173.73,
    y1: 118.26,
    x2: 9218.28,
    y2: 118.26,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f2f2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 9195.89,
    cy: 128.05,
    r: 18.12,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 9195.89,
    cy: 128.05,
    r: 18.47,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 9195.89,
    cy: 128.05,
    r: 11.45,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#020200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0a0a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#21211f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#464645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0c0c0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#131311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#252523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 9195.89,
    cy: 128.05,
    r: 3.46,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 9194.27,
    y1: 126.92,
    x2: 9198.22,
    y2: 129.67,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0b0b0b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 9195.85,
    cy: 128.05,
    r: 1.77,
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 9195.29,
    y1: 122.85,
    x2: 9196.63,
    y2: 123.78,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 9195.48,
    y1: 122.98,
    x2: 9196.36,
    y2: 123.59,
    gradientTransform: "translate(-9110.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 9195.31,
    y1: 132.49,
    x2: 9196.65,
    y2: 133.41,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 9195.5,
    y1: 132.62,
    x2: 9196.38,
    y2: 133.23,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 9191.13,
    y1: 125.27,
    x2: 9192.46,
    y2: 126.19,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 9191.31,
    y1: 125.4,
    x2: 9192.19,
    y2: 126.01,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 9199.48,
    y1: 130.07,
    x2: 9200.82,
    y2: 131,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 9199.67,
    y1: 130.2,
    x2: 9200.55,
    y2: 130.81,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 9191.14,
    y1: 130.09,
    x2: 9192.47,
    y2: 131.01,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 9191.32,
    y1: 130.22,
    x2: 9192.2,
    y2: 130.83,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 9199.47,
    y1: 125.25,
    x2: 9200.81,
    y2: 126.18,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 9199.66,
    y1: 125.38,
    x2: 9200.54,
    y2: 125.99,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1588.62,
    y1: 115.15,
    x2: 1588.62,
    y2: 124.44,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1686.06,
    y1: 0.23,
    x2: 1686.06,
    y2: 102.64,
    gradientTransform: "matrix(1, 0, 0, -1, -1573.37, 103.34)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#cacac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7bbb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1750.89,
    y1: 108.95,
    x2: 1752.83,
    y2: 108.95,
    gradientTransform: "matrix(1, 0, 0, -1, -1704.85, 217.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1778.22,
    y1: 108.95,
    x2: 1780.16,
    y2: 108.95,
    gradientTransform: "matrix(1, 0, 0, -1, -1759.52, 217.9)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1767.13,
    y1: 110.79,
    x2: 1767.13,
    y2: 112.75,
    gradientTransform: "matrix(1, 0, 0, -1, -1735.52, 223.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#989898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1604.97,
    y1: 109.36,
    x2: 1607.11,
    y2: 109.36,
    gradientTransform: "matrix(1, 0, 0, -1, -1413.2, 218.73)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1640.69,
    y1: 109.36,
    x2: 1642.83,
    y2: 109.36,
    gradientTransform: "matrix(1, 0, 0, -1, -1484.64, 218.73)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1679.58,
    y1: 109.36,
    x2: 1681.72,
    y2: 109.36,
    gradientTransform: "matrix(1, 0, 0, -1, -1562.42, 218.73)",
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1642.15,
    y1: 111.51,
    x2: 1642.15,
    y2: 113.53,
    gradientTransform: "matrix(1, 0, 0, -1, -1485.55, 225.24)",
    xlinkHref: "#linear-gradient-41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1681.41,
    y1: 103.04,
    x2: 1681.41,
    y2: 109.44,
    gradientTransform: "matrix(1, 0, 0, -1, -1564.07, 212.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1686.22,
    y1: 103.45,
    x2: 1686.22,
    y2: 114.15,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#858c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#979c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#b5b8b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cbccca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#eaedec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#e4e6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9dad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#cacac9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: -4429.72,
    cy: 117.68,
    r: 20.12,
    gradientTransform: "translate(4590.38 983.12) rotate(12.78)",
    xlinkHref: "#radial-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: -4429.72,
    cy: 117.68,
    r: 20.51,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: -4429.72,
    cy: 117.68,
    r: 14.25,
    xlinkHref: "#radial-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 1546.74,
    cy: 123.63,
    r: 21.13,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#191918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 1550.64,
    cy: 74.63,
    r: 24.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1497.24,
    y1: 77.6,
    x2: 1573.71,
    y2: 77.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7bbb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc1be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d2d6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#e1e4e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e9eceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ecefee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e4e5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#dededd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#dcdcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#dadad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d3d4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c8cac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#bec1bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#b7bbb7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: -4547.02,
    cy: 128.26,
    r: 18.09,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: -4547.02,
    cy: 128.26,
    r: 18.44,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: -4547.02,
    cy: 128.26,
    r: 11.43,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: -4547.02,
    cy: 128.26,
    r: 3.45,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -4548.64,
    y1: 127.14,
    x2: -4544.69,
    y2: 129.88,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -4547.06,
    cy: 128.26,
    r: 1.77,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#radial-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -4547.62,
    y1: 123.07,
    x2: -4546.28,
    y2: 124,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -4547.43,
    y1: 123.2,
    x2: -4546.55,
    y2: 123.81,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -4547.6,
    y1: 132.69,
    x2: -4546.26,
    y2: 133.62,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -4547.41,
    y1: 132.82,
    x2: -4546.53,
    y2: 133.43,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -4551.78,
    y1: 125.49,
    x2: -4550.44,
    y2: 126.41,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -4551.59,
    y1: 125.62,
    x2: -4550.71,
    y2: 126.23,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -4543.44,
    y1: 130.28,
    x2: -4542.1,
    y2: 131.21,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -4543.25,
    y1: 130.41,
    x2: -4542.37,
    y2: 131.02,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -4551.77,
    y1: 130.3,
    x2: -4550.43,
    y2: 131.22,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -4551.58,
    y1: 130.43,
    x2: -4550.7,
    y2: 131.04,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -4543.45,
    y1: 125.47,
    x2: -4542.11,
    y2: 126.39,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -4543.26,
    y1: 125.6,
    x2: -4542.38,
    y2: 126.21,
    gradientTransform: "translate(4795.78)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -3212.84,
    y1: 131.48,
    x2: -3193.17,
    y2: 131.85,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2424.44, 111.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#464644"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -3200.15,
    y1: 139.03,
    x2: -3200.15,
    y2: 134.21,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2424.44, 111.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5c5c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8e8e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#b6b6b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d6d6d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ededec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -3212.71,
    y1: 124.67,
    x2: -3193.25,
    y2: 125.04,
    gradientTransform: "matrix(0.66, 0.04, -0.02, 1, 2424.44, 111.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1505.49,
    y1: 120.84,
    x2: 1504.62,
    y2: 120.84,
    gradientTransform: "matrix(1, 0, 0, -1, -1211.36, 241.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1aeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a7a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#919090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1518.72,
    y1: 111.63,
    x2: 1518.72,
    y2: 128.63,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#363838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#202121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#191a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#080909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1505.5,
    y1: 120.17,
    x2: 1509.52,
    y2: 120.17,
    gradientTransform: "matrix(1, 0, 0, -1, -1216.28, 240.34)",
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1523.07,
    y1: 120.17,
    x2: 1531.85,
    y2: 120.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#989897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#777776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#626261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5b5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1526.63,
    y1: 119.38,
    x2: 1531.88,
    y2: 121,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#616563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6b706f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#707170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#727271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5c5e5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2e3536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1d2527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0c0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 3603.8,
    cy: 79.06,
    r: 4.99,
    gradientTransform: "matrix(-1, 0, 0, 1, 3847.19, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 3603.15,
    y1: 80.06,
    x2: 3603.15,
    y2: 78.1,
    gradientTransform: "matrix(-1, 0, 0, 1, 3847.19, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#171716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#282826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2b2b29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#363635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 12303.96,
    y1: -276.44,
    x2: 12309.84,
    y2: -276.44,
    gradientTransform: "translate(-11990.5 -600.95) rotate(4.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#636360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7c7c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9d9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -13023.68,
    y1: -275.88,
    x2: -13022.98,
    y2: -275.88,
    gradientTransform: "matrix(-1, -0.08, -0.08, 1, -12703.41, -658.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -13023.68,
    y1: -275.72,
    x2: -13020.59,
    y2: -277.11,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 13496.47,
    y1: -274.4,
    x2: 13498.39,
    y2: -277.64,
    gradientTransform: "translate(-13175.15 -695.28) rotate(4.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5bfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 13492.99,
    y1: -276.64,
    x2: 13498.25,
    y2: -276.64,
    gradientTransform: "translate(-13175.15 -695.28) rotate(4.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 12359.4,
    y1: 196.26,
    x2: 12359.95,
    y2: 196.26,
    gradientTransform: "translate(-12042.61 -615.18) rotate(2.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b6b6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 12305.31,
    y1: -275.19,
    x2: 12305.85,
    y2: -275.19,
    gradientTransform: "translate(-11990.5 -600.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 12303.96,
    y1: -276.57,
    x2: 12309.84,
    y2: -276.57,
    gradientTransform: "translate(-11990.5 -600.95) rotate(4.55)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 12303.96,
    y1: -276.44,
    x2: 12309.83,
    y2: -276.44,
    gradientTransform: "translate(-11990.5 -600.95) rotate(4.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#d5d5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9d9d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1554.29,
    y1: 107.18,
    x2: 1585.87,
    y2: 131.42,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1566.43,
    y1: 103.36,
    x2: 1566.43,
    y2: 104.96,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1546.16,
    y1: 37.57,
    x2: 1546.72,
    y2: 42.86,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e7e7e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#d8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#bbbaba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a6a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#999797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#959393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1508.77,
    y1: 60.97,
    x2: 1559.47,
    y2: 60.97,
    gradientTransform: "matrix(-1, 0, 0, 1, 1798.75, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#637771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a19d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.77,67.83h.9a.29.29,0,1,0,0-.58h-.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.74,67.25h-.9a.29.29,0,1,0,0,.58h.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.38,83v1.76a.29.29,0,0,0,.29.29.3.3,0,0,0,.3-.29V83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.42,61.45l-1.76-.17a.29.29,0,1,0-.06.58l1.76.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.29,83l-.14,1.76a.29.29,0,1,0,.58,0l.14-1.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.43,63.48h-.06a.28.28,0,0,0-.35.22.28.28,0,0,0,.21.34h.08Z"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 3,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAABCAYAAAAb4BS0AAAACXBIWXMAAAsSAAALEgHS3X78AAAAD0lEQVQIW2P8//8/AwwAACD5Av8tIlAeAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 155.28,
    cy: 146.67,
    rx: 155.28,
    ry: 10.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.67,146.18c0,2.83,8.71,5.13,19.46,5.13s19.47-2.3,19.47-5.13S258.88,141,248.13,141,228.67,143.34,228.67,146.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 239.38,
    cy: 140.13,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.81,146.4c0,2.84,8.72,5.14,19.47,5.14s19.46-2.3,19.46-5.14-8.71-5.14-19.46-5.14S65.81,143.56,65.81,146.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 92.63,
    cy: 142.62,
    rx: 19.47,
    ry: 5.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 147.73,
    y: 107.93,
    width: 48.21,
    height: 16.34,
    rx: 1.1,
    transform: "translate(343.67 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 147.73,
    y: 115.37,
    width: 48.21,
    height: 0.73,
    transform: "translate(343.67 231.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147.73,
    y: 116.09,
    width: 48.21,
    height: 0.73,
    transform: "translate(343.67 232.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M195,107.93h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0H195a1,1,0,0,1-1-1V109A1,1,0,0,1,195,107.93Z",
    transform: "translate(389.89 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.78,107.93h.93a0,0,0,0,1,0,0v16.34a0,0,0,0,1,0,0h-.93a1,1,0,0,1-1-1V109A1,1,0,0,1,148.78,107.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 192.14,
    y: 107.93,
    width: 1.26,
    height: 16.34,
    transform: "translate(385.55 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 150.33,
    y: 107.93,
    width: 1.26,
    height: 16.34,
    transform: "translate(301.93 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 191.41,
    y: 107.93,
    width: 0.72,
    height: 16.34,
    transform: "translate(383.54 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 149.61,
    y: 107.93,
    width: 0.72,
    height: 16.34,
    transform: "translate(299.94 232.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 193.41,
    y: 107.93,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 151.6,
    y: 107.93,
    width: 0.72,
    height: 16.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M7.53,116.58v4.25h11V116.5l6.26-1.33v-4.9H22.93v2.5L18.52,114v-7.45H16.73v8l-6.64,2.07Zm4.25,3.59v-2.45l5-.92v3.37Zm-3.81,0v-3h2.12v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M6.12,116.48H7.7a0,0,0,0,1,0,0v4.34a0,0,0,0,1,0,0H6.12a.22.22,0,0,1-.22-.22v-3.9A.22.22,0,0,1,6.12,116.48Z",
    transform: "translate(13.59 237.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 5.51,
    y: 116.48,
    width: 0.38,
    height: 4.34,
    transform: "translate(11.41 237.31) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 90.31,
    cy: 123.05,
    r: 18.31,
    transform: "translate(-60.56 99.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M106.48,121.29l2.43-.28-.42-2.4-2.39.57c-.06-.23-.11-.45-.17-.67l2.34-.7-.83-2.29-2.25,1c-.09-.21-.19-.42-.3-.62l2.2-1.1-1.22-2.11-2,1.34c-.13-.19-.27-.37-.41-.56l2-1.45-1.57-1.87-1.78,1.68c-.16-.17-.33-.33-.49-.49l1.69-1.78L101.38,108l-1.47,2c-.19-.14-.36-.29-.56-.41l1.35-2-2.11-1.22-1.1,2.2-.63-.31,1-2.24-2.29-.83-.7,2.34-.67-.17.57-2.38-2.4-.43-.28,2.43c-.23,0-.46,0-.69,0l.15-2.45H89.09l.15,2.45c-.23,0-.46,0-.69,0l-.28-2.43-2.4.43.57,2.38-.67.17-.7-2.34-2.29.83,1,2.24-.62.31-1.1-2.2-2.11,1.22,1.35,2a5.75,5.75,0,0,0-.56.41l-1.47-2-1.87,1.56,1.69,1.78c-.17.16-.33.32-.49.49l-1.78-1.68L75.22,112l2,1.45c-.14.19-.29.37-.41.56l-2-1.34-1.22,2.11,2.2,1.1c-.11.2-.21.41-.31.62l-2.24-1-.83,2.29,2.34.7c-.06.22-.12.44-.17.67l-2.39-.57-.42,2.4,2.42.28c0,.22,0,.46,0,.69l-2.45-.15v2.44l2.45-.15c0,.23,0,.46,0,.69l-2.42.28.42,2.41,2.39-.58c0,.23.11.45.17.67l-2.34.7.83,2.3,2.24-1c.09.21.2.42.3.62l-2.19,1.1,1.22,2.12,2-1.35c.13.19.27.37.41.56l-2,1.46L76.79,136l1.78-1.69.48.49-1.68,1.78,1.87,1.57,1.46-2,.56.41-1.34,2L82,139.83l1.09-2.19.63.3-1,2.24,2.29.84.69-2.35.67.17-.56,2.39,2.4.42.27-2.42.7,0-.15,2.45h2.44l-.15-2.45.7,0,.27,2.42,2.4-.42-.56-2.39.67-.17.69,2.35,2.29-.84-1-2.24.63-.3,1.09,2.19,2.11-1.22-1.34-2,.56-.41,1.46,2,1.87-1.57-1.69-1.78.49-.49,1.78,1.69,1.57-1.87-2-1.46c.13-.19.28-.37.41-.56l2,1.35,1.22-2.12-2.19-1.1.3-.62,2.24,1,.83-2.3-2.34-.7c.06-.22.12-.44.17-.67l2.39.58.42-2.41-2.43-.28c0-.23,0-.46,0-.69l2.45.15v-2.44l-2.45.15C106.51,121.75,106.51,121.51,106.48,121.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M90.31,110.08a13,13,0,1,0,13,13A13,13,0,0,0,90.31,110.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 39.75,
    y: 111.88,
    width: 38.29,
    height: 12.71,
    rx: 2.14,
    transform: "translate(117.78 236.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 134.19,
    y: 104.15,
    width: 1.26,
    height: 24.22,
    transform: "translate(216.55 -41.9) rotate(76.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 104.53,
    y: 105.93,
    width: 3.72,
    height: 34.25,
    rx: 0.63,
    transform: "translate(201.33 -9.04) rotate(76.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 101.63,
    y: 103.61,
    width: 125.05,
    height: 11.63,
    transform: "translate(328.32 218.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 101.63,
    y: 112.42,
    width: 125.05,
    height: 2.82,
    transform: "translate(328.32 227.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 13.51,
    y: 104.81,
    width: 88.13,
    height: 7.34,
    transform: "translate(115.14 216.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 13.51,
    y: 110.37,
    width: 88.13,
    height: 1.78,
    transform: "translate(115.14 222.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M104.08,115.15a21.24,21.24,0,0,0-18.5-10.23A21.84,21.84,0,0,0,67,115.22C79.44,115,90.77,115,104.08,115.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M110,130.18s2.86-26.63-24.73-26.63c-25.46,0-24.89,22.91-24.65,26.45h4s-2-22.57,20.66-22.57,20.71,23,20.71,23S107.69,130.37,110,130.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M84.78,106.06C62.51,106.06,63,126.65,63.25,130h1.39s-2-22.57,20.66-22.57,20.71,23,20.71,23l1.72-.11h0S109,106.06,84.78,106.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M88,106.52c-.25,1.83,9.5,1.21,14.37,9s2.65,12.15,5.06,12.15c2,0,2.17-9.33-2.09-15.58C100.22,104.58,88.43,103.42,88,106.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M89.08,106.82c-.27,1.7,8.8,1.29,13.35,8.56s2.64,11.47,4.9,11.47c1.93,0,2-8.77-2.07-14.66C100.44,105.14,89.52,104,89.08,106.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90.14,107.11c-.28,1.59,8.09,1.38,12.34,8.1s2.63,10.81,4.74,10.8c1.81,0,1.72-8.21-2.06-13.73C100.67,105.7,90.6,104.47,90.14,107.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M91.2,107.41c-.3,1.46,7.38,1.46,11.32,7.64,4.07,6.35,2.63,10.14,4.58,10.12,1.7,0,1.49-7.65-2-12.81C100.89,106.26,91.68,105,91.2,107.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M92.25,107.7c-.31,1.34,6.68,1.55,10.31,7.19,3.8,5.86,2.62,9.46,4.43,9.44,1.59,0,1.26-7.09-2-11.89C101.11,106.83,92.76,105.53,92.25,107.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M93.31,108c-.33,1.22,6,1.64,9.29,6.73,3.52,5.37,2.62,8.79,4.27,8.76,1.48,0,1-6.53-2-11C101.33,107.39,93.84,106.05,93.31,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M94.37,108.29c-.35,1.1,5.25,1.74,8.27,6.28,3.25,4.88,2.61,8.12,4.12,8.08s.8-6-2-10C101.55,108,94.92,106.58,94.37,108.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M95.43,108.59c-.37,1,4.55,1.82,7.25,5.81,3,4.4,2.61,7.45,4,7.41s.58-5.41-2-9.12C101.77,108.51,96,107.11,95.43,108.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M96.49,108.88c-.39.86,3.84,1.91,6.24,5.36,2.71,3.91,2.6,6.78,3.79,6.72s.35-4.84-2-8.19C102,109.07,97.06,107.63,96.49,108.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M97.55,109.18c-.42.73,3.13,2,5.22,4.9,2.45,3.42,2.59,6.1,3.64,6s.12-4.27-2-7.27C102.22,109.63,98.13,108.15,97.55,109.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M98.61,109.47c-.45.61,2.43,2.08,4.2,4.45,2.19,2.92,2.59,5.43,3.48,5.36s-.11-3.71-1.94-6.34S99.19,108.67,98.61,109.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M99.67,109.76c-.48.49,1.73,2.17,3.18,4,1.93,2.43,2.58,4.75,3.33,4.68s-.34-3.15-1.93-5.42S100.25,109.19,99.67,109.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 85.36,
    cy: 128.05,
    r: 18.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M101.36,126.3l2.4-.27-.42-2.38-2.36.56c0-.22-.11-.44-.17-.66l2.32-.69-.82-2.26-2.23,1c-.09-.21-.19-.42-.29-.62l2.17-1.08-1.21-2.09-2,1.32c-.13-.19-.27-.36-.41-.55l2-1.44-1.56-1.85L97,116.91l-.48-.48,1.67-1.76-1.85-1.55-1.45,1.95c-.19-.13-.36-.28-.55-.41l1.33-2-2.09-1.2-1.09,2.17c-.2-.1-.41-.21-.62-.3l1-2.22-2.27-.82-.69,2.32-.66-.18.56-2.35-2.37-.42-.28,2.4c-.22,0-.45,0-.68,0l.14-2.42H84.15L84.3,112c-.23,0-.46,0-.68,0l-.28-2.4-2.38.42.57,2.35-.66.18-.7-2.32-2.26.82,1,2.22c-.21.09-.41.2-.62.3l-1.08-2.17-2.09,1.2,1.33,2c-.19.13-.37.28-.55.41l-1.45-1.95-1.85,1.55,1.67,1.76-.49.48L72,115.25l-1.55,1.85,1.95,1.44c-.13.19-.27.36-.4.55l-2-1.32-1.2,2.09,2.17,1.08c-.1.2-.21.41-.3.62l-2.22-1-.82,2.26,2.32.69c-.07.22-.12.44-.17.66l-2.37-.56L67,126l2.4.27c0,.23,0,.46,0,.68l-2.43-.14v2.42l2.43-.15c0,.22,0,.45,0,.68l-2.39.28.41,2.38,2.36-.57c.06.22.11.44.17.66l-2.31.69.82,2.27,2.22-1c.09.2.19.41.29.61l-2.16,1.09,1.2,2.09L72,137c.13.19.27.37.41.55L70.43,139,72,140.85l1.76-1.67.48.48-1.66,1.77L74.41,143l1.44-2c.18.14.36.28.55.41l-1.32,2,2.09,1.2,1.08-2.17.61.3-1,2.22,2.26.82.69-2.32.66.17L81,146l2.38.42.27-2.4c.23,0,.46,0,.69,0l-.15,2.42h2.41l-.14-2.42c.23,0,.46,0,.69,0l.27,2.4,2.37-.42-.56-2.36.67-.17.68,2.32,2.27-.82-1-2.22.62-.3,1.08,2.17,2.09-1.2-1.33-2,.56-.41,1.44,2,1.85-1.55-1.67-1.77.49-.48,1.75,1.67,1.56-1.85-2-1.45c.13-.18.28-.36.4-.55l2,1.33,1.21-2.09-2.17-1.09c.1-.2.21-.41.3-.61l2.22,1,.82-2.27-2.32-.69c.07-.22.12-.44.17-.66l2.36.57.42-2.38-2.4-.28c0-.23,0-.46,0-.68l2.42.15v-2.42l-2.42.14C101.39,126.76,101.39,126.53,101.36,126.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 85.36,
    cy: 128.05,
    r: 11.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M85.36,124.59a3.46,3.46,0,1,0,3.46,3.46A3.46,3.46,0,0,0,85.36,124.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M85.36,125.64a2.41,2.41,0,1,0,2.4,2.41A2.41,2.41,0,0,0,85.36,125.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M85.32,126.28a1.77,1.77,0,1,0,1.77,1.77A1.77,1.77,0,0,0,85.32,126.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M85.31,122.42a.81.81,0,1,0,.81.81A.81.81,0,0,0,85.31,122.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M85.31,122.7a.54.54,0,0,0-.54.53.54.54,0,1,0,.54-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M85.33,132.06a.81.81,0,1,0,.81.81A.81.81,0,0,0,85.33,132.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M85.33,132.33a.54.54,0,1,0,.53.54A.54.54,0,0,0,85.33,132.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M80.44,125.24a.81.81,0,1,0,1.4.81.81.81,0,0,0-1.4-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M80.68,125.38a.53.53,0,1,0,.73-.19A.54.54,0,0,0,80.68,125.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M88.79,130a.82.82,0,1,0,1.11-.29A.81.81,0,0,0,88.79,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M89,130.18a.54.54,0,0,0,.93.54.53.53,0,0,0-.2-.73A.54.54,0,0,0,89,130.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M80.74,129.76a.82.82,0,0,0-.29,1.11.81.81,0,1,0,1.4-.81A.81.81,0,0,0,80.74,129.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M80.88,130a.53.53,0,0,0,.54.92.53.53,0,0,0-.54-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M89.08,124.93a.81.81,0,0,0-.3,1.11.81.81,0,1,0,.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M89.22,125.17a.53.53,0,1,0,.53.92.53.53,0,0,0,.2-.73A.54.54,0,0,0,89.22,125.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "200.74 124.63 226.68 124.63 226.68 115.24 193.58 115.24 200.74 124.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 4.92,
    y: 0.87,
    width: 215.53,
    height: 101.6,
    transform: "translate(225.38 103.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 45.99,
    y: 104.92,
    width: 1.92,
    height: 8.06,
    transform: "translate(93.9 217.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 18.66,
    y: 104.92,
    width: 1.92,
    height: 8.06,
    transform: "translate(39.23 217.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 12.42,
    y: 110.94,
    width: 38.29,
    height: 3.17,
    transform: "translate(63.14 225.05) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "44.65 114.11 48.36 114.11 50.71 110.94 47.01 110.94 44.65 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "36.58 114.11 40.29 114.11 42.64 110.94 38.94 110.94 36.58 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "28.51 114.11 32.22 114.11 34.58 110.94 30.87 110.94 28.51 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "20.45 114.11 24.15 114.11 26.51 110.94 22.8 110.94 20.45 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "12.38 114.11 16.08 114.11 18.44 110.94 14.73 110.94 12.38 114.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 12.52,
    y: 110.94,
    width: 38.19,
    height: 1.85,
    transform: "translate(63.23 223.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 191.71,
    y: 104.92,
    width: 2.12,
    height: 8.89,
    transform: "translate(385.55 218.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 156,
    y: 104.92,
    width: 2.12,
    height: 8.89,
    transform: "translate(314.11 218.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 117.1,
    y: 104.92,
    width: 2.12,
    height: 8.89,
    transform: "translate(236.33 218.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 113.36,
    y: 111.66,
    width: 86.48,
    height: 3.29,
    transform: "translate(313.2 226.61) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "192.42 114.95 196.95 114.95 199.84 111.66 195.3 111.66 192.42 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "182.54 114.95 187.08 114.95 189.96 111.66 185.42 111.66 182.54 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "172.66 114.95 177.2 114.95 180.08 111.66 175.55 111.66 172.66 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "162.78 114.95 167.32 114.95 170.21 111.66 165.67 111.66 162.78 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "152.91 114.95 157.44 114.95 160.33 111.66 155.79 111.66 152.91 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "143.03 114.95 147.56 114.95 150.45 111.66 145.91 111.66 143.03 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "133.15 114.95 137.69 114.95 140.57 111.66 136.03 111.66 133.15 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "123.27 114.95 127.81 114.95 130.69 111.66 126.16 111.66 123.27 114.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "113.39 114.95 117.93 114.95 120.81 111.66 116.28 111.66 113.39 114.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 113.36,
    y: 111.66,
    width: 86.48,
    height: 1.92,
    transform: "translate(313.2 225.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 218,
    height: 104,
    transform: "translate(3.61 -0.14)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAABoCAYAAACXH+6lAAAACXBIWXMAAAsSAAALEgHS3X78AAACy0lEQVR4Xu3dwU4TURQG4HOHRheC+AYYfRNJGl7TEOJK40vVICtJyqKROi6aYksHDDrniOH7NgyTmUJCTu5/z70ztLMPZ/3hq8OAMe11e9HvnO0HD8d2788dvmAUwx/bx+W3y5hEi3j7+k1cXHyN79fL6LN+C3hiNitpcnOyjzh+d9wGrgf+wOnp+/7o6CgiIrqIVZEBeboIgxhk61Zf+kibIcKT9WsQ69YH4iOMq22ExS6AdF1r69HMkAZZREdI0trOHE2VQaau/7EuMsUGWW4WrEVHGNdAdAQymaNBgY2uo2KDMYmOUMzufSiwMaKpNhjT4IK1UQ3ymKNBgY05miENxuV5NEg38DyaKoNMuo6QRnSEdK1FnJ+fx4v9fQvWkGWxWNwcewsWpFrFR9EREq06j70Fa0jXW7CGEl1ExPPnz0RHSLDeWCw6QgEL1pCsDyMaJGux1XU0R4PxrTcWG9EgW2+OBsnsDIF0oiMUudV1NKTB+ERHSGdTMRQSHSFV227vi44wPl1HKKLrCOk8JgPpdrqO5miQR3SEVLe6jkAe0RESDbT3VRqMr3mVAVQRHSHRwKZilQZZREdIZVMxpNN1hCK6jpDOqwwgnefRoIz2PiTzPBrU0N6HXNr7UMKmYigjOkIim4qhhK4jlBEdIVFb/Qtr0RFy6TpCGdERElmwhhKrSZroCAVER0ik6wglLFhDia32/mKxuOdS4G8Y0SDRwKZiYHzmaFBGoUGigfY+MD6biqGMQoNE3lQMJWwqhjIKDRKJjlCiae9DBe19KKLQIFFr9jpCEe19KKHQIJHoCEV67X2oodAgkegIZfqYREQcHLyMiIjZbObljpBgcr28jslkEtPpye+uBR5gOj2J5XIZs/MvMZnPr+Lj50/rl/Xca/uSNng45NHcN/Dt3af/8X0Dp4Y/6hHct3H67j/Nw+6bz692Lv2f/QSr6bucdIWQpwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 13.51,
    y: 103.08,
    width: 207.66,
    height: 6.35,
    transform: "translate(234.67 212.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M3.89,103.08V106H202.38l5,7.22a1.17,1.17,0,0,0,.95.5H220a1.16,1.16,0,0,0,1.16-1.16v-9.46ZM206,108.61a1.16,1.16,0,0,1,1.16-1.15H212a1.16,1.16,0,0,1,1.16,1.15v2.45a1.16,1.16,0,0,1-1.16,1.16h-3.27a1.15,1.15,0,0,1-.95-.5l-1.51-2.18A1.63,1.63,0,0,1,206,108.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 244.43,
    cy: 117.68,
    r: 20.12,
    transform: "translate(-19.98 57) rotate(-12.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M262.2,115.74l2.67-.3-.47-2.64-2.62.62c-.06-.25-.12-.49-.19-.74l2.58-.76-.92-2.51-2.47,1.06q-.15-.34-.33-.69l2.42-1.2-1.34-2.32-2.24,1.48c-.14-.21-.3-.41-.45-.62l2.17-1.6-1.73-2-1.95,1.85q-.27-.28-.54-.54l1.85-2-2.05-1.73L255,103.27c-.2-.15-.4-.31-.61-.45l1.48-2.24-2.32-1.34-1.21,2.41-.69-.33,1.08-2.46L250.19,98l-.77,2.57-.74-.19.63-2.62-2.64-.46-.31,2.66c-.25,0-.5,0-.75,0l.16-2.69h-2.68l.17,2.69c-.26,0-.51,0-.76,0l-.31-2.66-2.64.46.63,2.62-.74.19L238.67,98l-2.52.91,1.08,2.46-.69.33-1.21-2.41L233,100.58l1.48,2.24c-.21.14-.41.3-.61.45l-1.61-2.17-2.05,1.73,1.85,2q-.27.25-.54.54l-1.95-1.85-1.73,2,2.17,1.6c-.15.21-.31.41-.45.62l-2.24-1.48L226,108.58l2.42,1.2q-.18.34-.33.69l-2.47-1.06-.92,2.51,2.58.76c-.07.25-.13.49-.19.74l-2.62-.62-.47,2.64,2.67.3c0,.25,0,.51,0,.76l-2.7-.16V119l2.7-.17c0,.26,0,.51,0,.76l-2.67.31.47,2.64,2.62-.63c.06.25.12.5.19.74l-2.58.77.92,2.52,2.46-1.08c.1.24.22.46.33.69L226,126.78l1.34,2.32,2.24-1.48c.14.21.3.41.45.61l-2.17,1.61,1.73,2,1.95-1.85.53.54-1.84,2,2.05,1.72,1.6-2.17c.21.15.4.31.61.45L233,134.78l2.32,1.34,1.2-2.42q.34.18.69.33l-1.07,2.47,2.52.92.76-2.58.74.19-.62,2.62,2.64.47.3-2.67c.25,0,.51,0,.77.05l-.17,2.7h2.68l-.16-2.7c.26,0,.51,0,.76-.05l.3,2.67,2.64-.47-.62-2.62.74-.19.76,2.58,2.52-.92L251.64,134q.35-.15.69-.33l1.2,2.42,2.32-1.34-1.48-2.24c.22-.14.41-.3.62-.45l1.6,2.17,2.05-1.72-1.85-2q.29-.27.54-.54l1.95,1.85,1.73-2-2.17-1.61c.15-.2.31-.4.45-.61l2.24,1.48,1.34-2.32-2.41-1.21c.11-.23.22-.45.33-.69l2.46,1.08.92-2.52-2.58-.77c.07-.24.13-.49.19-.74l2.62.63.47-2.64-2.67-.31c0-.25,0-.5.05-.76l2.69.17v-2.68l-2.69.16C262.23,116.25,262.23,116,262.2,115.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M244.43,103.43a14.26,14.26,0,1,0,14.25,14.25A14.25,14.25,0,0,0,244.43,103.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 226.68,
    y: 95.58,
    width: 52.8,
    height: 30.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M293.25,81.29,275.63,81l-36.3-8a4.19,4.19,0,0,1-3.28-4.19l.61-27.18,34.23,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M266.9,111.77a13.1,13.1,0,0,0-12.24-8.41H225v-39l1.54-27.43a1.3,1.3,0,0,1,1.36-1.23c6.92.28,39.81,1.79,46.57,5,5.18,2.49,10.85,11.79,14.85,18,2.87,4.49,9.2,14.45,10.48,19.55,1.08,4.31,1.74,13.26,1.66,17.71-.1,5.9-1.81,23.52-1.81,23.52h-29.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M274.42,41.13c-4.67-3.16-41.77-5.24-44.24-4.37s-.88,30.91.5,33.81S273,82.06,276.74,82.7s16.7.79,17.93-1.46S287.34,49.86,274.42,41.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M274.29,41.17c-4.62-3.1-41.44-5.28-43.82-4.32s-.77,30.49.59,33.34,41.78,11.27,45.5,11.9,16.49.77,17.71-1.44S287.05,49.74,274.29,41.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M274.16,41.21c-4.56-3-41.12-5.31-43.4-4.26-2.44,1.12-.67,30.06.68,32.85s41.26,11.06,44.94,11.68,16.29.76,17.49-1.41S286.76,49.62,274.16,41.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M274,41.25c-4.51-3-40.8-5.34-43-4.21-2.43,1.26-.56,29.64.77,32.38s40.74,10.85,44.38,11.45,16.08.75,17.27-1.38S286.47,49.49,274,41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M273.89,41.29c-4.44-2.92-40.46-5.37-42.55-4.15-2.41,1.39-.45,29.22.86,31.9S272.43,79.67,276,80.26s15.88.73,17.05-1.35S286.18,49.37,273.89,41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M273.76,41.33c-4.39-2.86-40.13-5.39-42.13-4.1-2.39,1.54-.35,28.8,1,31.43s39.71,10.41,43.26,11,15.67.72,16.83-1.32S285.89,49.25,273.76,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M273.63,41.37c-4.33-2.8-39.8-5.4-41.71-4-2.36,1.68-.24,28.37,1,31s39.2,10.2,42.69,10.77,15.48.7,16.62-1.3S285.6,49.12,273.63,41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M273.5,41.41c-4.28-2.75-39.47-5.42-41.29-4-2.34,1.83-.13,28,1.12,30.48s38.69,10,42.14,10.54,15.27.68,16.4-1.27S285.31,49,273.5,41.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M273.37,41.45c-4.22-2.69-39.14-5.43-40.87-3.93-2.31,2,0,27.53,1.21,30s38.18,9.77,41.58,10.32,15.07.67,16.18-1.24S285,48.87,273.37,41.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M273.24,41.49c-4.17-2.63-38.8-5.44-40.45-3.88-2.27,2.14.08,27.11,1.3,29.52s37.66,9.56,41,10.09,14.86.66,16-1.21S284.73,48.75,273.24,41.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M273.1,41.53c-4.1-2.57-38.45-5.44-40-3.82-2.23,2.3.19,26.68,1.39,29s37.14,9.34,40.46,9.86,14.66.65,15.74-1.19S284.44,48.63,273.1,41.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M273,41.57c-4.05-2.51-38.1-5.45-39.6-3.77-2.19,2.46.29,26.26,1.48,28.57s36.63,9.13,39.9,9.63,14.45.63,15.52-1.16S284.15,48.5,273,41.57Z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 63,
    height: 76,
    transform: "translate(232.61 37.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABMCAYAAADa6W+wAAAACXBIWXMAAAsSAAALEgHS3X78AAAEcElEQVR4XuWc3WscVRjGn/fsbD4lTdyIRtfaQBVJqeZS/SOCaMxHbbBUUqK9aKyVbqIOZInrRatps0nbbEygiAipoFYQL7z0zpvQSqIFCeLKypJty0qaguu+XmxmdzKdnckmsx8z5wfLzp592Tnvec4588zh7ICZob0G+45we+Bhbm3dx4P9R/jra9/yxMQE62O89CJmxuXoHKc3UngksA9nx1SMjo5CCAEhyPTdRw+WHwg+iujlBXzz3Q8InRnDU537MfL2CKGGIWbG9IXz/FBzI44Pn9xVZcPhMJuV+/0++BUfFMUHv6Jsvftw67dVLF5dwsWpKAaP9u/qnE5AP36/xH/Ek7tOvFSKNZRGd1cnXuk/hsnJSYTGxspaJ1qIzTCAiiVvhbFhgh0BxBMpPNfVjZd7exyvHy3EZrgWEi9GOBzmYEcA7W0t6OkdcrSewi6g2qiqSvFECut30rj+1eeWQ6ZUBDv6c+VBVVU6PnySllfWcC7yoWM1FoBjv1V2VFWlzYwfTU1NjlTaFcrrUVWVQqEQ3j/7wZ5r7irl9dQ31yES+WhPlXed8kBOfQDIZP6zC7Wk5mf7YmgNYGearBDs0m4PFBqgoaFhV0kIF+eeZ3x83C7EFOH23DX1py98UnIqAm6c8QxoDXD61JmSknG98hp30xtoDbTYhW3DtbO9EU39Uvy/YA90ez3LK2t2IXk8ozxQ+rXflQ7PilIawLXe3gk8YXKMaOq/+MJLltl55lJnxvCbr1t+79lury1/Wd33e27CM1LfXFf0O09d6oxoY//KpSumEnvO5JiRXE+alntaeaCgvhmeH/MaZp7fs7O9kfU76QfKPH2d19Aue8Hgk9vS9aTDK8aJE8PbPrt6AbMUzCY+qZQHgGtfxPIZSzHm9az+/nf+2BMLmDtF6/rR6SgDEioPAIeefgyABA7PjJ9+XgUgibfXo5/1pVQeyK3xSePtjcTmYvJ4eyPPH35W3m7/7qkReW5pjdz4dU3Obq/N+NIqn/5nU94xD0hocjSIJDY5fsUn540NACiKItctrR6plff7ffItY2koiiLPAqaRjXv35VW+ubFe3jGvKD45vT0AJJK35fT2H2/9SUGxC/QiJAiHDx6Q09sLIsx9dlVOby8EYfM+Vyb5xflZ3smOyEohiNDX91ruX9SVwJi81XaRcjP16Tl+5/R7VLEJT78lfHllDYvzsxxPpKrSCIJyp6xIt9fT0ztEqqpSY13u1NUYDkJUKXmNwTfeokPP7LcLKwtULeX1vDpwbMfbw53i0sxUYXOCVWAlKGV/vBMIEmhqrM8d28RWBFVVqburE4vzs2VvABKEX27eAFAjyQPAvc06xBMpu7A9I4jw5dJ1ADXk7QeG+omIONgRKOtjLIQgTJ2/mDu2ia0oTzweLLv6RISBo30E1JDyABD/608qhxXWG6lE8na+vKaSB4D2thYE2lq2HuEEMBhgxt30BpgZ2Swju/V4p2y28P5vJmN4/BPycZHIJGvl2WzhXP8DeXFlLHw5psgAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-97",
    cx: 248.77,
    cy: 128.26,
    r: 18.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M264.74,126.52l2.4-.27-.42-2.37-2.36.55c-.05-.22-.11-.44-.17-.66l2.32-.68-.83-2.27-2.21,1-.3-.62,2.17-1.07L264.13,118l-2,1.32c-.13-.19-.27-.36-.4-.55l1.95-1.44-1.55-1.84-1.76,1.66c-.16-.17-.32-.33-.49-.48l1.67-1.76-1.84-1.55-1.45,2c-.19-.14-.36-.28-.55-.41l1.33-2-2.09-1.21-1.08,2.17c-.21-.1-.41-.21-.62-.3l1-2.21-2.26-.83-.69,2.32c-.22-.07-.44-.12-.66-.17l.56-2.36-2.37-.42-.28,2.4c-.22,0-.45,0-.67-.05l.14-2.42h-2.41l.15,2.42c-.23,0-.46,0-.68.05l-.28-2.4-2.37.42.56,2.36c-.22,0-.44.1-.66.17l-.69-2.32-2.26.83,1,2.21c-.21.09-.41.2-.62.3l-1.08-2.17-2.09,1.21,1.33,2c-.19.13-.36.27-.55.41l-1.45-2L236,114.91l1.67,1.76c-.17.15-.33.31-.49.48l-1.76-1.66-1.55,1.84,1.95,1.44c-.13.19-.27.36-.4.55l-2-1.32-1.21,2.09,2.17,1.07-.3.62-2.21-1-.83,2.27,2.32.68c-.06.22-.11.44-.17.66l-2.36-.55-.41,2.37,2.39.27c0,.22,0,.45,0,.68l-2.43-.14v2.41l2.43-.15c0,.23,0,.46,0,.68l-2.39.28.41,2.37,2.36-.57c.05.23.11.45.17.67l-2.32.69.83,2.26,2.21-1c.09.21.2.41.3.61l-2.17,1.09,1.21,2.09,2-1.33c.13.19.27.36.41.55l-1.95,1.44,1.55,1.85,1.76-1.67.48.49L236,141.62l1.84,1.54,1.44-1.95.56.41-1.33,2,2.09,1.21,1.08-2.17.61.29-.95,2.22,2.26.82.68-2.31.67.17-.56,2.36,2.37.41.27-2.39.69,0-.15,2.42H250l-.14-2.42.68,0,.27,2.39,2.37-.41-.56-2.36.67-.17.68,2.31,2.26-.82-.95-2.22.61-.29,1.08,2.17,2.09-1.21-1.33-2,.56-.41,1.44,1.95,1.84-1.54-1.66-1.76c.17-.16.33-.32.48-.49l1.76,1.67,1.55-1.85-1.95-1.44c.14-.19.28-.36.41-.55l2,1.33,1.21-2.09-2.17-1.09c.1-.2.21-.4.3-.61l2.21,1,.83-2.26-2.32-.69c.06-.22.12-.44.17-.67l2.36.57.42-2.37-2.4-.28c0-.22,0-.45,0-.68l2.43.15v-2.41l-2.43.14C264.77,127,264.76,126.74,264.74,126.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M248.77,116.83a11.43,11.43,0,1,0,11.43,11.43A11.43,11.43,0,0,0,248.77,116.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M248.77,124.81a3.45,3.45,0,1,0,3.45,3.45A3.46,3.46,0,0,0,248.77,124.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M248.77,125.86a2.41,2.41,0,1,0,2.4,2.4A2.41,2.41,0,0,0,248.77,125.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M248.73,126.5a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,248.73,126.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M248.72,122.64a.81.81,0,1,0,.81.81A.81.81,0,0,0,248.72,122.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M248.72,122.92a.54.54,0,1,0,.53.53A.54.54,0,0,0,248.72,122.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M248.74,132.26a.81.81,0,1,0,0,1.62.81.81,0,0,0,0-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M248.74,132.54a.54.54,0,1,0,.53.53A.54.54,0,0,0,248.74,132.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M243.85,125.46a.81.81,0,1,0,1.11-.3A.81.81,0,0,0,243.85,125.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M244.09,125.6a.54.54,0,0,0,.2.73.53.53,0,1,0,.53-.92A.54.54,0,0,0,244.09,125.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M252.19,130.25a.82.82,0,1,0,1.11-.29A.81.81,0,0,0,252.19,130.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M252.44,130.39a.53.53,0,0,0,.92.54.53.53,0,0,0-.2-.73A.52.52,0,0,0,252.44,130.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M244.16,130a.81.81,0,0,0-.3,1.1.81.81,0,0,0,1.41-.81A.81.81,0,0,0,244.16,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M244.3,130.22a.53.53,0,1,0,.53.92.53.53,0,1,0-.53-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M252.48,125.15a.81.81,0,1,0,1.11.29A.81.81,0,0,0,252.48,125.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M252.62,125.39a.54.54,0,0,0-.19.73.52.52,0,0,0,.72.19.53.53,0,0,0,.2-.73A.54.54,0,0,0,252.62,125.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M301.66,114.54c-.13-1.57-12.51-1.64-12.88-1.36a20.83,20.83,0,0,1,3,7.72,65.29,65.29,0,0,1,.85,7.72s6.72,0,8.17-1.78C301.72,125.73,301.76,115.81,301.66,114.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M293.34,113.71c-.13.63.66,10.31,1.8,12,.88,1.28,4.19.62,4.86.66s2.12-7.91,1.5-11.83C301.33,113.44,293.54,112.73,293.34,113.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M293.62,113.76c-.12.61.72,9.53,1.77,11.09.82,1.2,3.91.72,4.54.75s2-7.48,1.44-11.07C301.2,113.51,293.8,112.81,293.62,113.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M293.9,113.81c-.11.58.78,8.76,1.75,10.2.75,1.12,3.63.81,4.21.84s1.94-7,1.37-10.32C301.07,113.57,294.07,112.9,293.9,113.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M294.18,113.87c-.09.55.84,8,1.72,9.3.68,1,3.35.91,3.89.93s1.84-6.61,1.31-9.56C300.94,113.64,294.34,113,294.18,113.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M294.46,113.92c-.08.52.9,7.2,1.69,8.41.62,1,3.07,1,3.57,1s1.75-6.19,1.24-8.81C300.8,113.71,294.6,113.08,294.46,113.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M294.75,114c-.08.49.95,6.42,1.65,7.51.56.88,2.8,1.09,3.25,1.12s1.65-5.75,1.18-8.06C300.67,113.78,294.86,113.17,294.75,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M295,114a29.31,29.31,0,0,0,1.62,6.62c.5.79,2.52,1.19,2.93,1.21s1.55-5.32,1.11-7.3C300.54,113.85,295.13,113.25,295,114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M295.31,114.08a26.42,26.42,0,0,0,1.6,5.73,4.84,4.84,0,0,0,2.6,1.3c.36,0,1.44-4.88,1.05-6.54C300.41,113.92,295.39,113.34,295.31,114.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M295.59,114.14a24.21,24.21,0,0,0,1.57,4.83,4.87,4.87,0,0,0,2.27,1.39c.32,0,1.35-4.45,1-5.79C300.27,114,295.66,113.43,295.59,114.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M295.87,114.19a22.64,22.64,0,0,0,1.54,3.94,4.94,4.94,0,0,0,1.95,1.48c.28,0,1.23-4,.93-5C300.13,114.06,295.92,113.52,295.87,114.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M296.15,114.25a22.46,22.46,0,0,0,1.51,3,5.37,5.37,0,0,0,1.63,1.57,10.47,10.47,0,0,0,.87-4.27C300,114.13,296.18,113.6,296.15,114.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M296.44,114.3c0,.32,1.29,1.76,1.47,2.15a6.38,6.38,0,0,0,1.31,1.67,9.77,9.77,0,0,0,.8-3.53C299.84,114.2,296.45,113.69,296.44,114.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M299.4,123.72a37.51,37.51,0,0,1-6.72-.13c.06,2.82,0,5,0,5s6.72,0,8.17-1.78c.34-.41.55-2,.69-4A8.86,8.86,0,0,1,299.4,123.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M301.66,114.54c-.13-1.57-12.51-1.64-12.88-1.36l.26,1.5a47.93,47.93,0,0,1,10.39-.23C300.37,114.61,301.69,114.91,301.66,114.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 293.25,
    y: 113.09,
    width: 0.88,
    height: 15.51,
    transform: "translate(587.39 241.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "270.18 128.6 293.25 128.6 293.25 111.74 266.81 111.74 270.18 123.45 270.18 128.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 289.23,
    y: 111.74,
    width: 4.02,
    height: 16.86,
    transform: "translate(582.47 240.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "275.68 128.6 270.29 128.6 270.61 121.3 266.9 111.74 275.68 111.74 275.68 128.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M293.25,124.81H271.52v-1.36h18.62a4,4,0,0,1,2.45.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M269,111.74l2.56,9.14a21.05,21.05,0,0,1,.79,5.75v2h-2.12v-2.14a21.45,21.45,0,0,0-.83-5.9l-2.54-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M296.29,76.49c-.65-1.31-1.17-5.85-11.53-22.71-4.12-6.72-8.27-10.16-7.18-10.9h0c4.26,3.83,8.56,10.84,11.78,15.88,2.65,4.16,8.28,13,10.11,18.34a2.47,2.47,0,0,1,.1.29s.29.11.29.11,0,.45,0,.81C299.84,78.31,296.94,77.8,296.29,76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M278.05,43.32c4.1,3.91,8.21,10.59,11.31,15.44,2.65,4.16,8.28,13,10.11,18.34,0,.1.07.19.1.29-.91-.26-2.31-.77-2.74-1.63-.65-1.3-1.49-5.77-11.85-22.64C281.83,48,278.75,45,278.05,43.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M241.43,79.06a3,3,0,1,0,3-3A3,3,0,0,0,241.43,79.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M238.3,80.1h11.47a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H238.3a1,1,0,0,0-1,1h0A1,1,0,0,0,238.3,80.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 283.91,
    y: 104.42,
    width: 6.26,
    height: 3.28,
    rx: 0.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 284,
    y: 104.46,
    width: 6.09,
    height: 3.17,
    rx: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 284.1,
    y: 104.49,
    width: 5.93,
    height: 3.06,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 284.19,
    y: 104.53,
    width: 5.76,
    height: 2.95,
    rx: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 284.28,
    y: 104.56,
    width: 5.59,
    height: 2.84,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 284.38,
    y: 104.6,
    width: 5.42,
    height: 2.73,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 284.47,
    y: 104.63,
    width: 5.26,
    height: 2.62,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 284.56,
    y: 104.67,
    width: 5.09,
    height: 2.5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 284.66,
    y: 104.71,
    width: 4.92,
    height: 2.39,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 284.75,
    y: 104.74,
    width: 4.76,
    height: 2.28,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 284.84,
    y: 104.78,
    width: 4.59,
    height: 2.17,
    rx: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 284.94,
    y: 104.81,
    width: 4.42,
    height: 2.06,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 284.11,
    y: 104.51,
    width: 5.72,
    height: 2.75,
    rx: 0.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 284.13,
    y: 104.52,
    width: 5.68,
    height: 2.66,
    rx: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 284.15,
    y: 104.53,
    width: 5.65,
    height: 2.58,
    rx: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 284.17,
    y: 104.53,
    width: 5.61,
    height: 2.5,
    rx: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 284.18,
    y: 104.54,
    width: 5.58,
    height: 2.41,
    rx: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 284.2,
    y: 104.55,
    width: 5.54,
    height: 2.33,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 284.22,
    y: 104.55,
    width: 5.51,
    height: 2.25,
    rx: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 284.24,
    y: 104.56,
    width: 5.47,
    height: 2.17,
    rx: 0.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 284.25,
    y: 104.57,
    width: 5.44,
    height: 2.08,
    rx: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 284.27,
    y: 104.58,
    width: 5.4,
    height: 2,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 284.29,
    y: 104.58,
    width: 5.37,
    height: 1.92,
    rx: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 284.31,
    y: 104.59,
    width: 5.33,
    height: 1.83,
    rx: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 284.32,
    y: 104.6,
    width: 5.3,
    height: 1.75,
    rx: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 284.34,
    y: 104.6,
    width: 5.26,
    height: 1.67,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 284.36,
    y: 104.61,
    width: 5.23,
    height: 1.58,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 284.38,
    y: 104.62,
    width: 5.19,
    height: 1.5,
    rx: 0.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 284.39,
    y: 104.62,
    width: 5.16,
    height: 1.42,
    rx: 0.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 284.41,
    y: 104.63,
    width: 5.12,
    height: 1.33,
    rx: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 284.43,
    y: 104.64,
    width: 5.09,
    height: 1.25,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 284.45,
    y: 104.65,
    width: 5.06,
    height: 1.17,
    rx: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 284.46,
    y: 104.65,
    width: 5.02,
    height: 1.09,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 284.48,
    y: 104.66,
    width: 4.99,
    height: 1,
    rx: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M284.56,105a20.67,20.67,0,0,0,4.82.17c.2-.23.14-.47-.44-.5S284.53,104.65,284.56,105Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-174",
    width: 7,
    height: 8,
    transform: "translate(295.61 96.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAWklEQVQIW3WOwQnAIBRD81v3qEN4tKsFdB2X+i5Rj7+HogjVnJI8ApGUkmEh7y8cPZAUktKzav3gXM5+LFfaQufOPQwhwAFAzvn3OMYbYmZo7bFSClTrgCTlBTWLHF2gWwzaAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M302.08,98.3c0-.42-.11-.77-.33-.79L297,97.07c-.4,0-.76.7-.8,1.58l-.22,3.66c0,.58.14,1.08.41,1.12l4.85.84c.22,0,.43-.29.46-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M299.8,100.85c-.09,1.26,0,2.29.19,2.3s.42-1,.51-2.29,0-2.33-.2-2.32S299.88,99.58,299.8,100.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M300.3,98.54c-.19,0-.42,1-.5,2.31s0,2.29.19,2.3l-2.47-1.38.16-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M300.74,101.12c-.08,1.29,0,2.35.21,2.36s.44-1,.53-2.35,0-2.39-.21-2.38S300.83,99.82,300.74,101.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M296,102.3l.22-3.68c.05-.86.42-1.58.81-1.56l.77.06c.18,0,.3.33.28.73l-.28,5.34c0,.24-.11.42-.22.41l-1.17-.18C296.12,103.38,295.94,102.89,296,102.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M296.86,97.44c-.2.92,4,.36,4.49,1s.08,5.29.16,5.21.71-5.36.3-5.74C301.61,97.77,296.91,97.19,296.86,97.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M297.45,98.81c0,.76.05,1.37.2,1.36s.31-.66.34-1.43-.05-1.39-.2-1.36S297.48,98,297.45,98.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M297.29,101.8c-.05.76,0,1.39.18,1.4s.31-.61.36-1.38,0-1.41-.18-1.41S297.34,101,297.29,101.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M297.19,99.64c.76.09,3.29-.17,3.58.11s.13,4,.42,4.19a2.34,2.34,0,0,0,.36.11,1.05,1.05,0,0,0,.14-.5l.39-5.25a.22.22,0,0,0,0-.08c-.09-.42-.29-.71-.54-.73L297,97.07a.31.31,0,0,0-.22.06,1.31,1.31,0,0,0-.46.76c0,.09-.05.19-.07.29s0,.31-.05.47l0,.39A1.18,1.18,0,0,0,297.19,99.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M301.66,103.76l-4.9-1.73c-.28-.1-.46-.64-.43-1.28,0-.32,0-.68.06-1,.06-.93.06-1.78.45-2.12a4.18,4.18,0,0,1,1.72-.42l-.89-.08-.68-.06a.31.31,0,0,0-.22.06,1.31,1.31,0,0,0-.46.76c0,.09-.05.19-.07.29s0,.31-.05.47l-.22,3.66c0,.58.14,1.08.41,1.12l4.85.84C301.41,104.3,301.59,104.08,301.66,103.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M239.63,103.36a40.67,40.67,0,0,0-8.52,8.63,16.9,16.9,0,0,0-2.16,5.86c-.82,5.6-.83,14.19-1.25,16.29a17.49,17.49,0,0,1-1.74,5.6,4.9,4.9,0,0,1-2.13,1.81s.7-6.54.76-10.89c.1-5.92.45-27.3.45-27.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "239.63 103.36 225.04 103.36 225.02 104.97 237.6 104.97 239.63 103.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M274.51,40.71a14.24,14.24,0,0,1,3.55,2.61H226.22l.36-6.42a1.3,1.3,0,0,1,1.36-1.23C234.86,36,267.75,37.46,274.51,40.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M287.39,67.3l0-.06c-.36-.79-9.17-19.95-16.05-22.31-5.28-1.81-21.8-2.92-29.42-3.35a3.7,3.7,0,0,0-3.92,3.7V63.09a4.09,4.09,0,0,0,2.66,3.83L276,80.1a4.45,4.45,0,0,0,1.49.26h13.44a.58.58,0,0,0,.56-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M290,79.06s-4-12.33-6-15.81c-2.22-3.86-9.07-15.88-13.06-17.08-3.67-1.1-14.22-2.44-29.07-3.29h-.14a2.41,2.41,0,0,0-2.41,2.4V63.49a2.22,2.22,0,0,0,1.44,2.07l26.12,3.22A7.25,7.25,0,0,1,272,72l4.53,6.9a2.31,2.31,0,0,0,.83.15Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-84",
    width: 59,
    height: 43,
    transform: "translate(235.61 39.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAArCAYAAADG8/AoAAAACXBIWXMAAAsSAAALEgHS3X78AAADrElEQVRoQ91az2saWRz/vGkzQlq2hyhsL1UTctxCCISAudQGKuQP6J6kP445mC50ySkwxsOWBlq2h5Vtuw255/4sCeSQYL2kKeS4ZTQrQQjxmjGonz2EUZOoT/NDZ/qBz0Hn8x3f532+vnGeI0jCxpcvab548RvS6bQQQnBoaAherxderxeJRAKTk5MoFAooFouoVis4PCzi+/d/US6XUS5XUKmU8fLl7wIOhbDNzs3NMZlMYmxsDOl0+tSAhRD1GekQoVAIa2trKBQKyOVysCwL377twLJKWFhY6MuECJLIZrOcnp5GPp+HZVlXMhBd16nrOmwODAzg7OvNzU3k8/8hlUrh8LB4/ZNgGAY9Hg9HRkZIEr3i+Pg4Q6EQAZyiaZp89eqPaxkLpJT0+XzXcvJuCYCxWIwAuLu7S5W+W0JKyVAodOUnvgztlEulEhOJRar0nVITQqBarbbq8r6ApACAcDiMx49/Vck7xs0bNzRUKhWVrucgKYQQHB0dhWmaDAQCl168NE1zplmgnnAwGEQqler68ncWjjYL1A1HIhF8+vTPpQxrllVCuVxW6foK2/CzZ88Rj8cvbFgD4OhkbdiG5+fnVdKWcI1Z4MSwx+NBNpu9ULoaAMe38VkEg0F8/tz9guWqZIF6Oz96FFFJz8F1ZoG64W4vR640ayMSiXS1OrvyOwvU041GoyppDa5OFjhZrDpN19Vm7XRnZ2dVUgAubmMbJIXX68X7938r03V1so148uSpSvJjmCUpdF3Hu3d/tk1XA4CJiYl2GtegWm3fyTczmUxbgVtg3+zfv/8LHzwIN73R127fvoWtra0L7Q07EeHww9YHScI0zdq2pmrTyukEQCklmx3TACAQCIjl5WUAwNTU1A+RcFM0OpdSntu0Vs2k02iP2zAMnjvWrGBxcZG5XM61xtGilZWF6+vrPDg4cJVpAE03/pWFNpeWXnNjY8MVabdqZWVhM759+4b7+/uONg6A29vbPPWeqkhFKSWPj48JgMPDw/T7/Y4w3iwAZVGnNAyDmUyGfr+fPp+Pg4ODfTcNgMnkX7UxKAsuwo8fP9A0zb63OXDyf2/ttargspRS8ujoqC/Gz36WsuCqaBgGpZScmZnpqWkAXFp6TbKHZhtpGEbP2hwA9/b2SPbJbCNXV1evtc0bz6cU94p2m9vPVFylaeDkB0btOSgnIR6PMxqNYmVlBXfv/ox79/yqkrbQdR07O1/hSLON6HRPuB3u3PkJsdic+B/FVyTqxh8OuwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-84",
    width: 56,
    height: 41,
    transform: "translate(236.61 40.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAApCAYAAABgDOogAAAACXBIWXMAAAsSAAALEgHS3X78AAAEeElEQVRoQ9WYX0hbZxjGny/GK9cekjovqlnmIFNYNHjuXLCDOqG70IHaDu3AC8mFQ8h9J4FzkiaZXXGu1a5IVtaVDqReCN57oxfeBJxFVvDPigsI6/REyZaZnLy7qCdLmj/HNCY5+cELge89Od/zPc85H+djRAQAEEWRmpvfB8dxMJneQyKRwKtXfyISiUCSwohG/wERIR6PIxqNgoiSFY/LcLlcDBqEERH8fh+NjX0Fs9kMq9WKubk5tLe3Q6/X562xsTH09fWhoaEBL1/+DllOYGdnGwCwv7+PWCyGk5MTEBGi0X8rsgiMiLC6ukI3bnxx6pZ0pklYLBaqqanJEL22tpbR63Q6MTU1hRcvfsP29jbicRmh0B+IxWIIh49KKpwJgkAHBwdYXFzE7u5uSW7EGKNcY/Pz87DZbHj+fAN7e3vnL1gQBLLb7QSAUp+rchQAUkqZw8LCMxIE4dzmomMMSCQS+dagZBARU2plZYUBwMDAIIaHh+F2izldLwQdYwyyLKv1lQUiYgBgsVgwNDQMUSxepKYEAukie3t7ixapA6ApgcD/Inmeh9X6kVp7XnSMMcTjcbW+sqOIHBgYxOzszFu7qLmIpqKIPDo6xvT0d28lUq9lgcBrkYwxOjw8hNd7m27d+rqgPVKzEX0Tg8GAtrY2eDzugpzUdEQVlKj29X2OxsZGtfY0NPkWzYYiUpYTBW0dVeFgKg6Ho6Cto2qeQSB96zjrW7XqHFREXrnyyZmiqotE/oYsy6irq1Pr1RQ8z8NoNKi1vX7JWK3WqnTx2rXP4PN587qoU35Uk0AFi8UCjuPy9lStQMXF7u5P8347JgVW6qO3WEZHR9HU1JRzXAcAExMTORu0DBGx1dVVXLhwEXfvfpvdRSJCIBCo2LlMsYXTM52FhWeUbVwHAMfHR1haWoLdbgdjjPKdgmkNOn0WjcZL8Pt9mfNWlAqCQI8f/0SSJCVPupRSW8VKlzLPmZn79OYYO21I4naLxHEczGYz6ureQU9PD3iehyzLWF9fB52umNZgjFEwGERHR0fa/DIEpuLxuKm+vh5dXV24efNLSJIESZIQDoc1J5QxRk6nE0ajMf3gWM1+pTweNz158jNtbm5qMsLIEdO8DmZDFEXiuItoaWnB5cuNsNlsaeNUQWezxlRtZfKVz+elmZn7FAwGaWhoqOKuAqD+/n6anPwmeX/Vi85afr+PHj36kXZ2dioWYeV+Dx/+kLxnwRFVQ4mwyWTC1avdMBjSP2moxBHOiKnaqhRTgiDQvXvfUzAYJKfTWRZXAdDIyAh5vbeJ6BwjqlZ37kxSIBCgUChU0ggr//ngwSwRlSCiaoiiSHp9DVpbW9HfPwDG0hNL5xBhxhhtbPwKq7WNlV1gKsrz2tnZiadPf8H09HRyrBihjDEaHx9HQ8O75XcwF6IoUn39JXR2fgye5wEAy8vL2NraUrkyE4fDAbvdjuvXB7UjUEEURaqtrUVLy4dobv4A4XBY7ZKsHBz8hVAopD2BqZzlWDAfLpeL/QedX7EVCP4mJAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M274.2,58.44a17.28,17.28,0,0,0-14-9.59l-20.9-1.78h0V45.28a2.41,2.41,0,0,1,2.41-2.4h.14c14.85.85,25.4,2.19,29.07,3.29,4,1.2,10.84,13.22,13.06,17.08,2,3.48,6,15.81,6,15.81h-12.6a2.31,2.31,0,0,1-.83-.15l-1.7-2.58,5.65,0a1.56,1.56,0,0,0,1.39-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M267.73,69l8.82,10L271.88,46l-1.22-.43,2.23,24.34a.72.72,0,0,1-1,.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M290.29,89.5c2,0,2.72-.93,2.72-1.45V83.78a.65.65,0,0,0-.72-.65h-3.94a.73.73,0,0,0-.77.8c0,.59,0,3.29,0,4C287.6,88.49,288.43,89.5,290.29,89.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M288.36,83.18a.73.73,0,0,0-.74.81c0,.62,0,3.26,0,4a1.25,1.25,0,0,0,.56.87,3.41,3.41,0,0,0,2.08.6c2,0,2.65-.88,2.65-1.39v-4.2c0-.35-.25-.57-.71-.65h-3S288.36,83.17,288.36,83.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M288.37,83.22a.74.74,0,0,0-.7.82c0,.66,0,3.23,0,3.9a1.25,1.25,0,0,0,.57.83,3.58,3.58,0,0,0,2,.56c1.91,0,2.59-.85,2.59-1.35V83.85c0-.34-.25-.56-.7-.63l-1.34,0h-1.61S288.37,83.21,288.37,83.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M288.37,83.27a.73.73,0,0,0-.65.83c0,.69,0,3.2,0,3.84a1.23,1.23,0,0,0,.57.78,3.75,3.75,0,0,0,2,.52c1.84,0,2.52-.8,2.52-1.29V83.88c0-.33-.25-.54-.7-.62l-1.31,0h-1.59A7.64,7.64,0,0,0,288.37,83.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M288.38,83.31c-.28,0-.61.27-.61.85s0,3.18.05,3.78a1.17,1.17,0,0,0,.57.74,4,4,0,0,0,1.93.47c1.76,0,2.45-.76,2.45-1.24v-4c0-.32-.25-.53-.69-.61l-1.3,0h-1.56A6.9,6.9,0,0,0,288.38,83.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M288.38,83.36c-.26,0-.56.28-.57.85,0,.76,0,3.15.06,3.73,0,.21.24.45.58.69a4.11,4.11,0,0,0,1.87.44c1.7,0,2.39-.72,2.39-1.19V83.94c0-.31-.25-.51-.68-.6-.09,0-1.15,0-1.28,0H289.2A5,5,0,0,0,288.38,83.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M288.39,83.4c-.24,0-.52.31-.53.87,0,.79,0,3.13.06,3.67,0,.2.25.42.58.64a4.4,4.4,0,0,0,1.83.4c1.62,0,2.32-.68,2.32-1.14V84c0-.3-.25-.5-.67-.59-.11,0-1.11,0-1.26,0h-1.53A4.49,4.49,0,0,0,288.39,83.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M288.4,83.44c-.23,0-.48.33-.49.88,0,.83,0,3.11.07,3.62,0,.19.26.39.58.6a4.9,4.9,0,0,0,1.78.36c1.55,0,2.24-.64,2.24-1.09V84c0-.28-.24-.48-.66-.57-.12,0-1.06-.07-1.23-.07h-1.51A4,4,0,0,0,288.4,83.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M288.4,83.49c-.2.05-.43.34-.44.89,0,.86,0,3.08.07,3.56,0,.18.27.36.59.55a5.27,5.27,0,0,0,1.72.32c1.48,0,2.18-.6,2.18-1V84c0-.27-.24-.47-.65-.56a11.19,11.19,0,0,0-1.22-.08h-1.48A2.66,2.66,0,0,0,288.4,83.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M288.41,83.53c-.19.06-.39.36-.41.91,0,.9,0,3,.08,3.5,0,.17.28.32.6.51a6.09,6.09,0,0,0,1.67.28c1.41,0,2.11-.57,2.11-1V84.06c0-.26-.24-.46-.64-.55a10.81,10.81,0,0,0-1.2-.08h-1.46A2.42,2.42,0,0,0,288.41,83.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M288.42,83.58c-.17.06-.35.38-.37.91a29.39,29.39,0,0,0,.09,3.45c0,.16.29.29.59.46a7.13,7.13,0,0,0,1.63.24c1.33,0,2-.52,2-.93V84.09c0-.25-.24-.44-.63-.54a10.32,10.32,0,0,0-1.18-.09h-1.44A1.9,1.9,0,0,0,288.42,83.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M288.42,83.62c-.15.07-.3.4-.32.93a26,26,0,0,0,.09,3.39.83.83,0,0,0,.6.41,6.38,6.38,0,0,0,1.57.2c1.27,0,2-.48,2-.88V84.13c0-.25-.24-.44-.62-.54a8.09,8.09,0,0,0-1.16-.1h-1.43A1.76,1.76,0,0,0,288.42,83.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M288.43,83.67c-.13.08-.27.41-.28.94a23.07,23.07,0,0,0,.09,3.33c0,.14.29.29.61.37a7.46,7.46,0,0,0,1.52.16c1.19,0,1.91-.44,1.91-.83V84.16c0-.24-.23-.42-.62-.52a6.3,6.3,0,0,0-1.14-.11h-1.4C288.9,83.53,288.47,83.59,288.43,83.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M288.43,83.71a1.58,1.58,0,0,0-.24,1,21.39,21.39,0,0,0,.11,3.28c0,.14.29.27.6.32a9.43,9.43,0,0,0,1.48.12c1.12,0,1.84-.4,1.84-.77V84.19c0-.23-.23-.41-.61-.51a5.27,5.27,0,0,0-1.12-.12h-1.38C288.87,83.56,288.48,83.62,288.43,83.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M288.44,83.76a2.08,2.08,0,0,0-.2,1,17.86,17.86,0,0,0,.11,3.21c0,.14.3.25.61.29.06,0,1.3.08,1.42.08,1.05,0,1.78-.36,1.78-.73V84.22c0-.21-.23-.39-.6-.5a5,5,0,0,0-1.1-.13H289.1A1.12,1.12,0,0,0,288.44,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M288.45,83.8a2.65,2.65,0,0,0-.16,1,16.12,16.12,0,0,0,.11,3.16c.06.13.31.22.62.24,0,0,1.31,0,1.37,0,1,0,1.71-.32,1.71-.67V84.25c0-.2-.23-.38-.59-.49a4.23,4.23,0,0,0-1.08-.14h-1.34A.92.92,0,0,0,288.45,83.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M289.08,88.13h1.32c.9,0,1.64-.28,1.64-.63V84.28c0-.34-.74-.62-1.64-.62h-1.33c-.3,0-.56.08-.62.19a15.07,15.07,0,0,0,0,4.08C288.51,88.05,288.77,88.13,289.08,88.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M289.85,85.48c-.11-.22,1.32,3,2.64,2.86.73-.07.16-4.82,0-5-.42-.43-3.25-.3-3.72-.08S290,85.75,289.85,85.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M289.93,85.38c-.1-.19,1.25,2.81,2.51,2.69.69-.06.17-4.52.05-4.65-.39-.4-3.06-.29-3.51-.08S290.07,85.63,289.93,85.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M290,85.28c-.09-.17,1.18,2.64,2.37,2.53.67-.06.2-4.23.08-4.35-.36-.39-2.87-.28-3.31-.09S290.14,85.51,290,85.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M290.09,85.19c-.09-.16,1.11,2.45,2.23,2.35.64-.05.22-3.93.11-4.05-.33-.37-2.68-.27-3.11-.09S290.21,85.39,290.09,85.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M290.17,85.09c-.08-.13,1,2.28,2.1,2.19.6,0,.23-3.64.13-3.75-.3-.36-2.49-.27-2.9-.11S290.28,85.27,290.17,85.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M290.25,85c-.07-.11,1,2.11,2,2,.58,0,.26-3.34.16-3.46-.27-.34-2.3-.26-2.7-.11S290.35,85.15,290.25,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M290.33,84.9c-.07-.1.9,1.93,1.82,1.85.55,0,.28-3,.19-3.16-.24-.31-2.11-.25-2.49-.11S290.42,85,290.33,84.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M290.41,84.8c-.06-.08.83,1.75,1.69,1.69.51,0,.29-2.75.21-2.86-.21-.3-1.92-.25-2.29-.12S290.49,84.91,290.41,84.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M290.49,84.7c-.05-.06.76,1.58,1.55,1.52.49,0,.31-2.45.24-2.56-.19-.28-1.73-.24-2.09-.13S290.56,84.79,290.49,84.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M290.57,84.61c-.05,0,.69,1.4,1.41,1.35.46,0,.34-2.16.27-2.27s-1.54-.23-1.88-.13S290.63,84.67,290.57,84.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M290.65,84.51s.62,1.23,1.27,1.18c.43,0,.36-1.86.3-2s-1.35-.22-1.68-.14S290.71,84.55,290.65,84.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M290.73,84.41s.55,1.06,1.14,1c.4,0,.37-1.56.32-1.67s-1.16-.21-1.48-.14S290.77,84.43,290.73,84.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M290.81,84.32s.48.87,1,.85.39-1.27.35-1.37-1-.21-1.27-.16S290.84,84.31,290.81,84.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M290.88,84.22s.42.7.87.68.42-1,.38-1.07-.78-.2-1.07-.16S290.91,84.19,290.88,84.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M291,84.12a1,1,0,0,0,.74.52c.31,0,.43-.68.4-.78s-.59-.19-.87-.16S291,84.07,291,84.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M291,84a.68.68,0,0,0,.6.34c.28,0,.45-.37.43-.47s-.4-.19-.66-.17A.37.37,0,0,0,291,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M291.12,83.93c0,.1.21.18.46.18s.46-.08.46-.18-.21-.18-.46-.18S291.12,83.83,291.12,83.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(290.61 66.86)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "translate(289.61 66.86)",
    xlinkHref: "#image"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(288.61 66.86)",
    xlinkHref: "#image"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(290.61 82.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAAIUlEQVQIWwXBsQ0AIAwDMJOVjqj/fxrsg0LuDJCkaN4u+D3gA2z/jnOcAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 24,
    transform: "translate(285.61 60.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAYCAYAAAA20uedAAAACXBIWXMAAAsSAAALEgHS3X78AAAAb0lEQVQoU7WPMQrDMBAE5wTqbCK5MnpC8P8fZtJPiuBgcOJCoINtbncWlpyza2s+ahWw1KKKCoDTPLu2JvCVShyJ80WEz22Do+KssiwC/iUB0sUBUvq8f5oRcWN2k2lQbTfZv3PUlDG1t+Rr3wF4A23FMgrqovD4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(284.61 60.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQIWwXBsREAAAgCsaeX3nP/HSkxEdC9AyAJaoukjs3YPJfOCH48m4vsAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("image", {
    width: 2,
    height: 4,
    transform: "translate(287.61 82.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAECAYAAACk7+45AAAACXBIWXMAAAsSAAALEgHS3X78AAAALElEQVQIW2Pk5uX9r6GpwcDEy8vLICQkxMD0//9/Bhk5OQYGCSmp/8zMzP8Bd+oHqJbkHooAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 3,
    height: 22,
    transform: "translate(287.61 62.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAWCAYAAAAFMyaXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAjElEQVQYV22PMQ6CUBAFZ3/YThL9GEJiQaNewOhVLLg28RhILKB8FgtUbDd5mUkWQO+ukyQMEMDj9SRJMoBh+JIAjjkzT1PAbxw5VRUmicJd7g6ScHcBSgCWEkA4ySzS63K93Rcw49P3ETiUpSSxH9hgfznXtViuMDMubRtUN42ASK9yuMTLWy3nDMAfes8vWXhqrUoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("image", {
    width: 4,
    height: 2,
    transform: "translate(284.61 62.86)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAACCAYAAAB/qH1jAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQIWwXBwQ0AIAwAIXQTk+4/nj5PUEHozLShWvDu9QHTZQxHZG9LmAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M282.56,74h4a2.11,2.11,0,0,0,2.11-2.11V57a2.3,2.3,0,0,0-2.29-2.29H282.5a1.09,1.09,0,0,0-1,.74,27.44,27.44,0,0,0-1.22,8.49,36.3,36.3,0,0,0,1.26,9.31A1.08,1.08,0,0,0,282.56,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M282.58,73.92h3.87a2.11,2.11,0,0,0,2.11-2.11V57.09a2.29,2.29,0,0,0-2.28-2.29h-3.76a1.08,1.08,0,0,0-1,.74,27.66,27.66,0,0,0-1.19,8.4,36.53,36.53,0,0,0,1.23,9.18A1.08,1.08,0,0,0,282.58,73.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M282.59,73.81h3.74a2.11,2.11,0,0,0,2.11-2.12V57.2a2.28,2.28,0,0,0-2.27-2.28h-3.63a1.05,1.05,0,0,0-1,.73A27.83,27.83,0,0,0,280.38,64,36.61,36.61,0,0,0,281.57,73,1.07,1.07,0,0,0,282.59,73.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M282.61,73.69h3.59a2.12,2.12,0,0,0,2.13-2.12V57.31A2.27,2.27,0,0,0,286.06,55h-3.49a1,1,0,0,0-1,.72A28.63,28.63,0,0,0,280.45,64a36.38,36.38,0,0,0,1.16,8.92A1,1,0,0,0,282.61,73.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M282.63,73.57h3.45a2.12,2.12,0,0,0,2.13-2.12v-14a2.27,2.27,0,0,0-2.27-2.26h-3.35a1,1,0,0,0-1,.72A28.92,28.92,0,0,0,280.52,64a36.31,36.31,0,0,0,1.12,8.79A1,1,0,0,0,282.63,73.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M282.65,73.46H286a2.13,2.13,0,0,0,2.13-2.13V57.52a2.26,2.26,0,0,0-2.26-2.25h-3.22a1,1,0,0,0-1,.71A28.72,28.72,0,0,0,280.58,64a36.76,36.76,0,0,0,1.09,8.67A1,1,0,0,0,282.65,73.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M282.67,73.34h3.17A2.13,2.13,0,0,0,288,71.21V57.63a2.25,2.25,0,0,0-2.25-2.25h-3.09a1,1,0,0,0-.95.71,29.59,29.59,0,0,0-1,8,36.11,36.11,0,0,0,1.06,8.53A1,1,0,0,0,282.67,73.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M282.69,73.23h3a2.14,2.14,0,0,0,2.15-2.14V57.74a2.24,2.24,0,0,0-2.25-2.24h-2.95a1,1,0,0,0-.94.7,30,30,0,0,0-1,7.88,36,36,0,0,0,1,8.4A1,1,0,0,0,282.69,73.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M282.71,73.11h2.88A2.14,2.14,0,0,0,287.74,71V57.85a2.24,2.24,0,0,0-2.24-2.24h-2.82a1,1,0,0,0-.93.7,30.54,30.54,0,0,0-1,7.79,36.77,36.77,0,0,0,1,8.28A1,1,0,0,0,282.71,73.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M282.73,73h2.74a2.15,2.15,0,0,0,2.15-2.15V58a2.23,2.23,0,0,0-2.23-2.23H282.7a.93.93,0,0,0-.91.7,30.74,30.74,0,0,0-.93,7.7,36,36,0,0,0,.95,8.14A.94.94,0,0,0,282.73,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M282.75,72.88h2.6a2.15,2.15,0,0,0,2.15-2.15V58.06a2.22,2.22,0,0,0-2.22-2.22h-2.56a.94.94,0,0,0-.9.7,31.8,31.8,0,0,0-.9,7.61,36.44,36.44,0,0,0,.92,8A.92.92,0,0,0,282.75,72.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M282.77,72.77h2.45a2.16,2.16,0,0,0,2.16-2.16V58.17A2.21,2.21,0,0,0,285.17,56h-2.42a.91.91,0,0,0-.89.69,32.32,32.32,0,0,0-.87,7.52,36.82,36.82,0,0,0,.88,7.89A.93.93,0,0,0,282.77,72.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M282.78,72.65h2.32a2.17,2.17,0,0,0,2.17-2.16V58.28a2.21,2.21,0,0,0-2.21-2.21h-2.29a.9.9,0,0,0-.88.69,33.08,33.08,0,0,0-.83,7.44A37.52,37.52,0,0,0,281.9,72,.91.91,0,0,0,282.78,72.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M282.8,72.54H285a2.17,2.17,0,0,0,2.17-2.17v-12a2.2,2.2,0,0,0-2.2-2.2h-2.16a.88.88,0,0,0-.86.68,33.7,33.7,0,0,0-.8,7.35,36.79,36.79,0,0,0,.81,7.62A.89.89,0,0,0,282.8,72.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M282.82,72.42h2A2.17,2.17,0,0,0,287,70.25V58.5a2.19,2.19,0,0,0-2.2-2.2h-2A.86.86,0,0,0,282,57a34.28,34.28,0,0,0-.78,7.26,37,37,0,0,0,.78,7.5A.87.87,0,0,0,282.82,72.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M282.84,72.31h1.9a2.18,2.18,0,0,0,2.17-2.18V58.61a2.19,2.19,0,0,0-2.19-2.19h-1.88a.86.86,0,0,0-.84.67,35.12,35.12,0,0,0-.74,7.17,37.94,37.94,0,0,0,.74,7.37A.86.86,0,0,0,282.84,72.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M282.86,72.19h1.75A2.18,2.18,0,0,0,286.8,70V58.72a2.19,2.19,0,0,0-2.19-2.19h-1.75a.84.84,0,0,0-.82.67,36,36,0,0,0-.71,7.09,37.27,37.27,0,0,0,.71,7.23A.84.84,0,0,0,282.86,72.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M284.49,62.91c-.15-.74,1.75,10.46,3.51,10,1-.24.22-16.75-.54-17.39s-3.74-1-4.36-.22S284.68,63.88,284.49,62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M284.56,62.53c-.13-.67,1.67,9.85,3.33,9.44.92-.22.25-15.72-.46-16.34s-3.53-1-4.13-.25S284.74,63.42,284.56,62.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M284.64,62.15c-.13-.6,1.57,9.23,3.14,8.86.89-.21.27-14.69-.39-15.3s-3.31-.94-3.89-.27S284.81,63,284.64,62.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M284.71,61.78c-.11-.54,1.48,8.61,3,8.26.84-.2.29-13.66-.32-14.24s-3.1-.93-3.67-.3S284.87,62.5,284.71,61.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M284.79,61.4c-.11-.47,1.38,8,2.78,7.68.8-.19.32-12.64-.25-13.2s-2.87-.9-3.43-.32S284.93,62,284.79,61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M284.86,61c-.1-.4,1.29,7.38,2.6,7.09.77-.17.34-11.6-.18-12.15s-2.65-.88-3.19-.35S285,61.58,284.86,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M284.93,60.64c-.08-.33,1.2,6.76,2.42,6.5.73-.15.37-10.57-.1-11.1s-2.44-.85-3-.37S285.06,61.12,284.93,60.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M285,60.27c-.08-.27,1.1,6.14,2.24,5.91.68-.14.39-9.54,0-10.05a2.83,2.83,0,0,0-2.72-.4C284,56.16,285.12,60.66,285,60.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M285.08,59.89c-.07-.2,1,5.53,2.06,5.32.65-.12.41-8.51,0-9a2.57,2.57,0,0,0-2.49-.42C284.21,56.17,285.19,60.2,285.08,59.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M285.16,59.51c-.06-.13.91,4.92,1.87,4.74.61-.11.44-7.49.11-8a2.32,2.32,0,0,0-2.25-.45C284.43,56.18,285.25,59.74,285.16,59.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M285.23,59.13c-.05-.07.82,4.3,1.69,4.15.57-.09.47-6.45.19-6.91a2,2,0,0,0-2-.47C284.64,56.19,285.32,59.27,285.23,59.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M285.3,58.76s.74,3.68,1.52,3.56c.53-.08.49-5.43.25-5.86a1.75,1.75,0,0,0-1.78-.5C284.86,56.2,285.36,58.82,285.3,58.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M285.38,58.38c0,.07.64,3.07,1.33,3,.49-.06.51-4.39.32-4.81a1.46,1.46,0,0,0-1.54-.52C285.08,56.21,285.42,58.36,285.38,58.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M285.45,58c0,.14.55,2.46,1.15,2.39s.54-3.37.4-3.77a1.26,1.26,0,0,0-1.32-.55C285.29,56.22,285.48,57.9,285.45,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M285.52,57.62c0,.21.46,1.85,1,1.8s.56-2.33.46-2.72a1,1,0,0,0-1.08-.57C285.51,56.23,285.54,57.44,285.52,57.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M285.6,57.25c0,.27.36,1.23.79,1.21s.58-1.31.54-1.67a.79.79,0,0,0-.85-.6C285.73,56.24,285.61,57,285.6,57.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M285.67,56.87a.61.61,0,1,0,1.22,0,.61.61,0,1,0-1.22,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.ea0486f181074113f49551b0d00b6619.svg";
export { ForwardRef as ReactComponent };